import { apiFetch } from "./client";

export interface RuntimeFeatures {
  assessment: boolean;
  web_interview: boolean;
  respondent_chat: boolean;
}

export interface RuntimeInfo {
  env: "prod" | "staging" | "dev" | string;
  features: RuntimeFeatures;
  /** Absolute URL of the respondent web-interview SPA on this deployment.
   *  The no-twin card links here so a not-yet-promoted respondent can go do
   *  their interview. `null` when unconfigured — the card hides the button. */
  web_interview_url: string | null;
}

export const runtimeApi = {
  info: () => apiFetch<RuntimeInfo>("/runtime/info"),
};
